module.exports = function() {
  return new Worker(__webpack_public_path__ + "59197bd271cf6f6a68a8.worker.js");
};